// React
import React from 'react';
// External
import {
    Container, Form, Row, Col
} from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { BiSearch } from 'react-icons/bi';
import { connect } from 'react-redux';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import NavbarSecondary from 'components/shared/organisms/NavbarSecondary/NavbarSecondary';
import PageTitleWithCart from 'components/shared/molecules/PageTitleWithCart/PageTitleWithCart';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import FooterBtnActions from 'components/shared/molecules/FooterBtnActions/FooterBtnActions';
import Stepper from 'components/shared/atoms/Stepper/Stepper';
import ProductList from 'components/new-booking/ProductList/ProductList';
import BookingSubmitted from 'components/new-booking/BookingSubmitted/BookingSubmitted';
import BookingDetails from 'components/new-booking/BookingDetails/BookingDetails';
import AlertDismissible from 'components/shared/atoms/AlertDismissible/AlertDismissible';
import CollectionDetails from 'components/new-booking/CollectionDetails/CollectionDetails';
import CollectionDetailsModel from 'models/CollectionDetails';
import {
    updateBooking,
    clearBooking
} from 'stores/actions';
import { createBooking, completeBooking, editBooking, addSpecialInstruction, getBooking } from 'services/booking';
// Utils
import getFormFieldVal from 'utils/getFormFieldVal';
import isNil from 'lodash/isNil';
// Constants
import COMMUNAL_VETUNITY_STEPS from 'constants/communalVetUnitySteps';
// Styles
import './styles.scss';
// Models
import Owner from 'models/Owner';
import Pet from 'models/Pet';
import Booking from 'models/Booking';
import OwnerPetDetailsForm from 'components/new-booking/OwnerPetDetailsForm/OwnerPetDetailsForm';
import VetService from 'services/vet';
import PRODUCT_LIST_FILTERS from 'constants/productListFilters';
import Selector from 'components/shared/atoms/Selector/Selector';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import SpecialInstructions from 'components/new-booking/SpecialInstructions/SpecialInstructions';
import { isEmptyObject } from 'jquery';
import isEmpty from 'lodash/isEmpty';
import config from 'config/config';
import Pusher from 'pusher-js';
import { BookingContext } from 'context/BookingContext';
import Address from 'models/Address';
import { logErrorToAtatus } from 'services/atatus';

const DEFAULT_ERROR_MSG = "Something went wrong. Please verify the information and try again.";

class PrivateCremation extends React.Component {
    constructor(props) {
        super(props);
        const filterFromStorage = localStorage.getItem('product-filter') ?? '';
        const searchFromStorage = localStorage.getItem('product-search') ?? '';
        // check url
        const isEdit = this.props.match.path === '/edit-booking-vetunity-communal/:id' ? true : false;
        this.filters = this.getCategoryFilters();
        this.state = {
            skip: false,
            headerTitle: '',
            owner: Owner(this.props.booking.owner),
            pet: Pet(this.props.booking.pet),
            bookingId: '',
            steps: this.getStepsArray(),
            divider: true,
            isSubmitted: false,
            isLoading: false,
            alertFail: {
                show: false,
                message: DEFAULT_ERROR_MSG,
            },
            filter: filterFromStorage !== '' ? filterFromStorage : this.filters[0].value,
            vetDetails: null,
            isEdit: isEdit,
            isBookingLoaded: false,
            bookingImage: '',
            ownerPetDetailsDisabled: false,
            isVetDirect: false,
            searchValue: searchFromStorage,
            isUnsubmitted: true,
            petWeightEditable: false,
            ownerDetailsDisabled: false,
            pageTitleText: this.props.booking.bookingOptionSelected.label == 'Communal Cremation - Stray/Wildlife' ? 'Stray/Wildlife' : 'Pet',
            collectionDetails: CollectionDetailsModel(localStorage.getItem('booking') ? JSON.parse(localStorage.getItem('booking')).collectionDetails : {}),
            rawServiceType: localStorage.getItem('booking') ? JSON.parse(localStorage.getItem('booking')).rawServiceType : {},
            hasCollectionDetails: false,
            errors: {},
            officeLocationAddress: '',
            officeLocationDetails: '',
            isDefaultLocation: false
        };
        this.formComponent = React.createRef();
        this.ownerPetformComponent = {
            owner: React.createRef(),
            pet: React.createRef(),
            collectionDetails: React.createRef()
        };
        this.formComponentSecondary = React.createRef();
        this.bookingDetailsRef = React.createRef();
        // if edit, get booking details
        if (isEdit) {
            this.getBookingDetails();
        } else {
            this.state.isBookingLoaded = true;
        }
    }

    componentDidMount() {
        this.setOwnerDetailsDisabledState()

        this.updateStepData();
        if (!this.state.isEdit) {
            this.getVetDetails();
        } else {
            localStorage.removeItem('is-pet-next');
        }
    }

    setSkipState() {
        if(!this.state.isEdit) {
            if (this.props.booking.bookingOptionSelected.label === 'Communal Cremation - Pet') {
                this.setState({
                    skip: this.props.booking.isProvideClientDetails = 0
                })
            }
            if (this.props.booking.bookingOptionSelected.label.toLocaleLowerCase().includes('wildlife')) {
                this.setState({
                    skip: this.props.booking.isProvideClientDetails = 1
                })
            }
        } else {
            const booking = localStorage.getItem('booking') ? JSON.parse(localStorage.getItem('booking')) : {}

            if(booking?.skipOwnerDetails) {
                this.setState({
                    skip: booking.skipOwnerDetails ? 1 : 0
                })
            }
        }
    } 

    setOwnerDetailsDisabledState() {
        const serviceTypeName = localStorage.getItem('service-type-name')

        if(serviceTypeName && serviceTypeName.toLocaleLowerCase() === 'communal cremation - stray / wildlife - vet') {
            this.setState({ownerDetailsDisabled: true})
        }
    }

    setCollectionDetailsState() {
        const collectionDetails =  CollectionDetailsModel(this?.props?.booking?.collectionDetails ? this.props.booking.collectionDetails : {})
        if(this?.props?.booking?.collectionDetails) {
            this.setState({
                collectionDetails: collectionDetails
            })
        }
    }

    handleShowCollectionDetails() {
        const serviceTypeName = localStorage.getItem('service-type-name')

        if(serviceTypeName && serviceTypeName.toLocaleLowerCase() === 'communal cremation - vet') {
            this.setState({hasCollectionDetails: true})
        }
    }

    componentDidUpdate(prevProps) {
        this.updateStepData();
        // set owner and pet details if booking is updated
        if ((prevProps.booking !== this.props.booking) && this.state.isEdit && !this.state.isBookingLoaded) {
            localStorage.setItem('service-type-name', this.props.booking.serviceType.name)
            this.subscribeToPusher();
            // get booking image
            this.props.booking.getImage().then((response) => {
                if (!isEmptyObject(response.data)) {
                    this.setState({bookingImage: response.data});
                }
            });
            // get vet relationship type
            VetService.getVetDetails().then((response) => {
                this.setCollectionDetailsState()
                let isVetDirect = false;
                if (response.data.cstm.relationship_type_c === "vet_direct") {
                    isVetDirect = true;
                }
                this.setState({isVetDirect}, () => {
                    this.props.booking.owner.phoneNumber = this.props.booking.owner.phoneNumber.replace("+61", "0");
                    this.setState({ petWeightEditable: this.props.booking.pet.weight === "" ? true : false, owner: this.props.booking.owner, pet: this.props.booking.pet, isBookingLoaded: true, vetDetails: response.data, isUnsubmitted: this.props.booking.parsedOrderStage?.includes('Unsubmitted')}, () => {
                        if (this.props.booking.parsedOrderStage.includes("Submitted") || this.props.booking.parsedOrderStage.includes("In Progress")) {
                            this.setState({ownerPetDetailsDisabled: true});
                        }
                    });
                });
                this.setSkipState();
            });
        }
    }

    componentWillUnmount() {
        if (this.channel) {
            // Unsubscribe from Pusher channel
            this.channel.unsubscribe();
        }
    }

    /**
     * [getBookingDetails get booking details]
     *
     */
    getBookingDetails() {
        getBooking(this.props.match.params.id)
            .then((response) => {
                const booking = Booking(response.data);
                this.props.updateBooking({...booking});
                // this.setCollectionDetailsState()
            }).catch((err) => {
                console.error('err :>> ', err);
            });
    }

    /**
     * Gets the category filters
     *
     * @returns {array}
     */
     getCategoryFilters() {
        const excludedFilters = ['Urns & Vessels', 'Memorabilia'];

        let filteredFilters = PRODUCT_LIST_FILTERS.filter(filter => !excludedFilters.includes(filter.name));

        // Remove the first (all) filter if there is only 2 filters left
        if (filteredFilters.length <= 2) {
            filteredFilters.shift();
        }

        return filteredFilters;
    }

    /**
     * Retrieves the vet details
     */
    getVetDetails = () => {
        VetService.getVetDetails()
            .then((response) => {
                const { data } = response;
                this.setSkipState()
                const serviceTypeName = localStorage.getItem('service-type-name')
                const isCommunalCremationVet = serviceTypeName.toLowerCase() === 'communal cremation - vet';
                const skip = isCommunalCremationVet ? data?.cstm?.provides_client_details_c !== '1' : true;
                const defaultCollectionLocationC = response?.data?.cstm?.default_collection_location_c
                let collectionDetails = {}

                if(defaultCollectionLocationC) {
                    // Determine collectionAddressOption based on response data
                    if (defaultCollectionLocationC === 'Vet') {
                        collectionDetails.collectionAddressOption = 'vet_address'
                    } else if (defaultCollectionLocationC === 'Customer') {
                        collectionDetails.collectionAddressOption = 'customer_address';
                    } else {
                        this.setState({
                            isDefaultLocation: true
                        });
                        collectionDetails = {
                            ...collectionDetails,
                            collectionAddressOption: 'postal_address',
                            collectionAddress: this.setCollectionDetailsAddress(response?.data?.office_location)
                        }
                    }
                }

                this.setState(prev => {
                    return {
                        ...prev,
                        vetDetails: response.data, 
                        officeLocationAddress: response?.data.office_location_address, 
                        officeLocationDetails: response?.data.office_location,
                        collectionDetails: CollectionDetailsModel(collectionDetails),
                        skip
                    }
                })
                
                this.handleShowCollectionDetails()
                this.ownerPetformComponent.owner.current.handleCheckbox(skip);
            }).catch((err) => {
                console.error(err);
            });
    }

    setCollectionDetailsAddress(officeLocation) {
        const ol = officeLocation

        return ol ? {
            street: ol.office_address_street,
            city: ol.office_address_city,
            state: ol.office_address_state,
            postalcode: ol.office_address_postalcode,
            country: ol.office_address_country,
            lat: ol.office_address_latitude,
            lng: ol.office_address_longitude,
        }: {}
    }

    handleInputChange(evt) {
        const skip = getFormFieldVal(evt);
        this.setState(skip);
    }

    getBookingOptionName() {
        return this.props.booking.id ? this?.props?.booking?.serviceType?.name : this?.props?.booking?.bookingOptionSelected?.label
    }

    /**
     * Submit the form based on the async form component submit
    */
   async onSubmit() {
       try {
            this.setState({ isLoading: true });
            localStorage.setItem('isWildLife', true);
            // Gets the data about the current form step
            const currentStepIndex = this.getCurrentStepIndex();
            const currentStepName = this.state.steps[currentStepIndex].name;

            if (this.state.isSubmitted) {
                this.props.history.push(`/booking/${this.state.bookingId}`);
            } else if (currentStepName === COMMUNAL_VETUNITY_STEPS.ownerPetDetails.name) {
                // handles the submission of the form of the current step
                // based on the private cremation steps
                // Saves the owner information enter on the form to continue with the pet information
                let ownerData;

                // Only save the owner details if the skip checkbox is not ticked
                if (!this.state.skip) {
                    ownerData = await this.saveOwnerDetails();
                }

                // Saves the pet information
                const petData = await this.savePetDetails();
                const collectionDetailsData = await this.saveCollectionDetails();
                let isWildLife = false;
                const isValidData = (ownerData || this.state.skip) && petData && !isEmpty(collectionDetailsData);

                if(this.props.booking.id) {
                    isWildLife = this?.props?.booking?.serviceType?.name?.toLocaleLowerCase() === 'communal cremation - stray / wildlife - vet'
                } else {
                    isWildLife = this?.props?.booking?.bookingOptionSelected.sugarAPIName?.toLocaleLowerCase() === 'communal cremation - stray / wildlife - vet'
                }

                // Go to next step after saving the owner and pet information
                if ((isValidData && !isWildLife) || isWildLife) {
                    await this.props.updateBooking({ skipOwnerDetails: this.state.skip });

                    // The booking is created once the owner details and pet details are filled
                    try {
                        await this.submitBooking();
                        // Go to next step after saving the booking information
                        localStorage.setItem('is-pet-next', true);
                        this.navigateNext();
                    } catch (error) {
                        logErrorToAtatus(`Failed to submit booking at ${this.getBookingOptionName()}`, {
                            ...error, 
                            message: error.message, 
                            booking_id: this.props.booking.id, 
                            booking_number: this.props.booking.orderId
                        })
                        await this.setState({
                            alertFail: {
                                ...this.state.alertFail,
                                show: true,
                            },
                            isLoading: false
                        });
                    } finally {
                        this.setState({ isLoading: false });
                    }
                } else {
                    await this.setState({ isLoading: false });
                }
            } else if (currentStepName === COMMUNAL_VETUNITY_STEPS.confirmation.name) {
                if (this.props.booking.id) {
                    try {
                        // Get the screenshot image of the booking details
                        const screenshot = await this.bookingDetailsRef.current.getImage();
                        if (this.state.isUnsubmitted) {
                            await completeBooking(this.props.booking.id, {
                                screenshotImage: screenshot,
                            });
                            // remove temporary booking flag when booking is complete
                            await localStorage.removeItem('createBookingFlag')
                        }
                        localStorage.setItem('is-pet-next', true);
                        this.setState({ isSubmitted: true, bookingId: this.props.booking.id });
                        this.props.clearBooking();
                    } catch (error) {
                        logErrorToAtatus(`Failed to submit booking at ${this.getBookingOptionName()}`, {
                            ...error, 
                            message: error.message, 
                            booking_id: this.props.booking.id, 
                            booking_number: this.props.booking.orderId
                        })

                        await this.setState({
                            alertFail: {
                                show: true,
                                message: "Error: " + (!isNil(error?.response?.data?.errors?.detail) ? error.response.data.errors.detail : DEFAULT_ERROR_MSG),
                            },
                            isLoading: false
                        });
                    } finally {
                        this.setState({ isLoading: false });
                    }
                } else {
                    await this.setState({ isLoading: false });
                }
            } else {
                // Products can click on next without verification
                this.navigateNext();
                await this.setState({ isLoading: false });
                localStorage.setItem('is-pet-next', true);
            }
        } catch (error) {
            logErrorToAtatus(`Failed to submit booking at ${this.getBookingOptionName()}`, {
                ...error, 
                message: error.message, 
                booking_id: this.props.booking.id, 
                booking_number: this.props.booking.orderId
            })
            this.setState({ isLoading: false });
        }
    }

    getStepsArray = () => {
        const stepsArray = Object.keys(COMMUNAL_VETUNITY_STEPS).map((key) => COMMUNAL_VETUNITY_STEPS[key]);

        // Check if $variable is true and modify the label of 'ownerPetDetails'
        const modifiedSteps = stepsArray.map(step => {
            if (step.name === 'ownerPetDetails' && this.props.booking.bookingOptionSelected.label === 'Communal Cremation - Stray/Wildlife') {
                return {
                    hash: '#owner-pet-details',
                    name: 'ownerPetDetails',
                    label: 'Owner and pet details',
                    title: 'Owner and pet details'
                };
            }
            return step; // Return the step unchanged if it's not 'ownerPetDetails' or $variable is false
        });
    
        return modifiedSteps;
    }

    /**
     * @returns the current index step
     */
    getCurrentStepIndex() {
        const currentStepHash = this.props.location.hash;
        for (const [index, step] of this.state.steps.entries()) {
            if (step.hash === currentStepHash) {
                return index;
            }
        }
        return null;
    }

    // Validates and stores the owner data from the form
    async saveOwnerDetails() {
        const owner = await this.ownerPetformComponent.owner.current.handleSubmit();

        if (owner) {
            const pet = Pet({ lastName: owner.lastName });
            this.setState({ owner: Owner(owner), pet });
            this.props.updateBooking({ owner: Owner(owner), pet });
            return owner;
        }
        return null;
    }

    // Validates and stores the pet data from the form
    async savePetDetails() {
        const pet = await this.ownerPetformComponent.pet.current.handleSubmit();
        if (pet) {
            this.setState({ pet: Pet(pet) });
            this.props.updateBooking({ pet: Pet(pet) });
            return pet;
        }
        return null;
    }

    // Validates and stores the pet data from the form
    async saveCollectionDetails() {
        if(!this.state.hasCollectionDetails) return true

        let collectionDetails = await this.ownerPetformComponent.collectionDetails.current?.handleSubmit(this.state);
        if (collectionDetails) {
            this.setState({ collectionDetails });
            this.props.updateBooking({ collectionDetails });
            return collectionDetails;
        }
        return null;
    }

    /**
     * Submits the booking with the owner and the pet information
     */
    async submitBooking() {
        if (this.state.pet && this.state.owner && this.state.collectionDetails) {
            let booking = Booking({
                ...this.props.booking,
                pet: this.state.pet,
                owner: this.state.owner,
                collectionDetails : this.state.hasCollectionDetails ? this.state.collectionDetails : null,
                vet_details: this.state.vetDetails,
                quotedProducts: this.state.collectionDetails.collectionProducts ?? [],
                isDefaultLocation: this.state.isDefaultLocation
            });
            const serviceTypeName = localStorage.getItem('service-type-name')
            // Submits the booking request
            const response = this.props.booking.id ? await editBooking(this.props.booking.id, booking.submitFormat()) : await createBooking(booking.submitFormat());
            const bookingData = Booking({
                ...response.data, 
                ...((serviceTypeName && serviceTypeName.toLocaleLowerCase() === 'communal cremation - vet') ? {collectionDetails:{}} : {})
            });
            // After the booking being created the special instructions are submitted
            const specialInstructions = await this.submitSpecialInstructions(bookingData.id);
            // Update booking
            this.props.updateBooking({ ...bookingData, ...specialInstructions });
            localStorage.setItem('bookingName', `${this.props.booking.orderId} ${this.props.booking.pet.firstName} ${this.props.booking.pet.lastName}`);
        }
    }

    /**
     * Submits the special instructions one by one (due to the Sugar API endpoints)
     * @param {string} bookingId
     */
     async submitSpecialInstructions(bookingId) {
        let specialInstructions = await this.formComponentSecondary.current.handleSubmit();
        if (specialInstructions && bookingId) {
            specialInstructions = specialInstructions.filter((item) => item);
            const response = await addSpecialInstruction(bookingId, specialInstructions);
            const booking = Booking({ specialInstructions: response.data });
            return { specialInstructions: booking.specialInstructions };
        }
        return { specialInstructions: [] };
    }

    navigateTo(path) {
        this.props.history.push(path);
        window.scrollTo(0, 0);
    }

    /**
     * Navigate to dashboard on cancel
     * @todo verify if you can leave the page
     */
    navigateCancel() {
        this.navigateTo('/dashboard');
    }

    /**
     * Handler to navigate to the next form after submitting the form,
     * it navigates to the next based on the current step
     */
    navigatePrev() {
        const currentStepHash = this.props.location.hash;
        let currentStepIndex = 0;
        this.state.steps.forEach((step, index) => {
            if (step.hash === currentStepHash) currentStepIndex = index;
        });
        if (currentStepIndex === 0) {
            // Navigates to new booking page if the current step is the initial
            this.navigateTo('/new-booking');
        } else if (currentStepIndex > 0) {
            // Navigates to the previous step
            const prevStep = currentStepIndex - 1;
            this.navigateTo(this.state.steps[prevStep].hash);
        }
    }

    /**
     * Handler to navigate to the next form after submitting the form,
     * it navigates to the next based on the current step
     */
    navigateNext() {
        const currentStepIndex = this.getCurrentStepIndex();
        const nextStep = currentStepIndex + 1;
        if (nextStep < this.state.steps.length) {
            this.navigateTo(this.state.steps[nextStep].hash);
        }
    }

    /**
     * Subscribe to Pusher
     */
    subscribeToPusher () {
        // get user data
        const userData = JSON.parse(localStorage.getItem('userData'));
        const userId = userData.id;
        // init pusher
        const pusher = new Pusher(
            config.PUSHER.key,
            {
                cluster: config.PUSHER.cluster,
                forceTLS: true,
                authEndpoint: config.PUSHER.presence_endpoint,
                auth: {
                    params: {
                        id: userId,
                        type: 'contact',
                    }
                }
            }
        )
        // subscribe to Pusher channel
        this.channel = pusher.subscribe('presence-' + this.props.booking.id);
    }

    /**
     * Updates the data of the current step based on the constant variable of the new booking steps
     */
    updateStepData() {
        const stepHash = this.props.location.hash;

        // If the hash is not define then navigates to the first step
        if (!stepHash) this.navigateTo(COMMUNAL_VETUNITY_STEPS.ownerPetDetails.hash);

        // Updates the information of the current step
        Object.keys(COMMUNAL_VETUNITY_STEPS).forEach((key, index) => {
            if (COMMUNAL_VETUNITY_STEPS[key].hash === stepHash) {
                const totalSteps = Object.keys(COMMUNAL_VETUNITY_STEPS).length;
                
                // Modify the title conditionally based on $variable
                let modifiedTitle = `Step ${index + 1} of ${totalSteps} - ${COMMUNAL_VETUNITY_STEPS[key].title}`;

                // If $variable is true, modify the title (e.g., append something to it)
                if (this.props.booking.bookingOptionSelected.label === 'Communal Cremation - Stray/Wildlife') {
                    modifiedTitle = modifiedTitle.replace(' - Owner, pet, and collection details', ' - Owner and pet details');
                }

                // If the current headerTitle state has changed, update it
                if (this.state.headerTitle !== modifiedTitle) {
                    this.setState({ headerTitle: modifiedTitle });
                }

                // If the current title state should also change, update it
                if (this.state.title !== modifiedTitle) {
                    this.setState({ title: modifiedTitle });
                }
            }
        })
    }

    /**
     * Returns subcomponent be displayed on the current step of the new booking
     */
    headerSubcomponentView() {
        const stepHash = this.props.location.hash;
        if (stepHash === COMMUNAL_VETUNITY_STEPS.ownerPetDetails.hash) {
            return (
                <div className="skip-checkbox">
                    <h3 className='step-title header-margin'>{this.state.headerTitle}</h3>
                    <div className="form-header">Owner Details</div>
                    <Form.Check
                        type="checkbox"
                        id="skip-checkbox"
                        label="Do not provide owner details"
                    >
                        <Form.Check.Input
                            type="checkbox"
                            name="skip"
                            onChange={this.handleSkip}
                            checked={this.state.skip}
                            disabled={this.state.ownerDetailsDisabled}
                        />
                        <Form.Check.Label>
                            Do not provide owner details
                            <span>If selected, owner details will be excluded from this booking</span>
                        </Form.Check.Label>
                    </Form.Check>
                </div>
            );
        }
        return null;
    }

    handleSkip = (event) => {
        this.setState(prev => {
            return {
                ...prev,
                skip: event.target.checked,
                owner: {
                    ...prev.owner,
                    address: !prev.skip ? Address('') : Address(this.ownerPetformComponent?.owner?.current?.state?.formData?.address)
                },
                collectionDetails: {
                    ...prev.collectionDetails,
                    collectionAddressOption: prev.skip && prev.collectionDetails.collectionAddressOption === 'customer_address' ? '' : prev.collectionDetails.collectionAddressOption
                }
            }
        })
        this.ownerPetformComponent.owner.current.handleCheckbox(event.target.checked);

        if(!this.state.skip) {
            this.ownerPetformComponent.owner.current.setInput(Address(this.ownerPetformComponent?.owner?.current?.state?.formData?.address)?.getSingleLineAddress())
        }
    }

    /**
     * Returns the form to be displayed on the current step of the new booking
     * @todo Add the keepsakes, urn, memorialisation and confirmation forms.
     */
    stepFormView() {
        const stepHash = this.props.location.hash;
        switch (stepHash) {
            case COMMUNAL_VETUNITY_STEPS.ownerPetDetails.hash:
                if (!this.state.divider) this.setState({ divider: true });
                if(this.state.isEdit) {
                    const booking = localStorage.getItem('booking') ? JSON.parse(localStorage.getItem('booking')) : {}
                    this.state.skip = booking?.skipOwnerDetails
                } 
                return (
                    <div>
                        <OwnerPetDetailsForm
                            formComponent={this.ownerPetformComponent}
                            formData={{
                                owner: this.state.owner,
                                pet: this.state.pet,
                                bookingImage: this.state.bookingImage
                            }}
                            hideForm={this.state.skip}
                            ownerPetDetailsDisabled={this.state.ownerPetDetailsDisabled}
                            isEdit={this.state.isEdit}
                            petWeightEditable={this.state.petWeightEditable}
                        />

                        {
                            this.state.hasCollectionDetails ?
                            <hr /> : null
                        }
                        {
                            this.state.hasCollectionDetails ?
                                <CollectionDetails
                                    ref={this.ownerPetformComponent.collectionDetails}
                                    formData={{
                                        collectionDetails: this.state.collectionDetails,
                                        officeLocation: this.state.officeLocationAddress,
                                        officeLocationDetails: this.state.officeLocationDetails
                                    }}
                                    booking={this.props.booking}
                                    defaultCollectionOption={this.props.booking.defaultCollectionOption}
                                    bookingForm={{...this.state}}
                                /> : null
                        }

                        <hr />
                        <SpecialInstructions
                            ref={this.formComponentSecondary}
                            specialInstructions={this.props.booking.specialInstructions}
                            ownerPetDetailsDisabled={this.state.ownerPetDetailsDisabled}
                        />
                    </div>
                );
                if (this.state.divider) {
                    this.setState({ divider: false });
                }
                return (
                    <Row className="productOptions">
                        <Col className="product">

                            <Row className="filter-search-subheader custom-no-caret">
                                <Form inline>
                                    <Container>
                                        <Row>
                                            <Col>
                                                <h3 className='step-title'>{this.state.headerTitle}</h3>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Control
                                                    id="search"
                                                    placeholder="Search"
                                                    value={this.state.searchValue}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            searchValue: event.target.value
                                                        }, () => {
                                                            localStorage.setItem('product-search', event.target.value);
                                                            const url = new URL(window.location.href);
                                                            url.searchParams.set('page', '1');
                                                            window.history.pushState(null, '', url.toString());
                                                        });
                                                    }}
                                                />
                                                <BiSearch size="18" />
                                            </Col>
                                            <Col>
                                                <Row>
                                                    <Col md={2} className="filter-label-col">
                                                        <span className="filter-label">Filter</span>
                                                    </Col>
                                                    <Col>
                                                        <Selector
                                                            options={this.filters}
                                                            name="filters"
                                                            onChange={(value) => {
                                                                const bFilterChanged = this.state.filter !== value;

                                                                this.setState({
                                                                    filter: value
                                                                }, () => {
                                                                    localStorage.setItem('product-filter', value);

                                                                    // Stop if the filter has not changed its value
                                                                    if (!bFilterChanged) {
                                                                        return;
                                                                    }

                                                                    // Get the query params from the url
                                                                    const queryParams = new URLSearchParams(this.props.location.search);
                                                                    const page = queryParams.get('page');

                                                                    // If the page is not set to 1, re-set it to 1 and reload the page
                                                                    if (page && page !== '1') {
                                                                        queryParams.set('page', 1);
                                                                        this.props.location.search = '?' + queryParams;
                                                                        this.props.history.push({
                                                                            pathname: this.props.location.pathname,
                                                                            search: this.props.location.search,
                                                                            hash: this.props.location.hash,
                                                                        });
                                                                        window.location.reload();
                                                                    }
                                                                });
                                                            }}
                                                            value={this.state.filter}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Container>
                                </Form>
                            </Row>
                            <ProductList ref={this.formComponent} search={this.state.searchValue} filter={this.state.filter} filterOptions={this.filters} />
                        </Col>
                        <Col className='cart'>
                            {
                                <PageTitleWithCart
                                    title={`${this.state.isEdit ? 'Edit' : 'New'} private cremation`}
                                    items={this.props.booking.getQuotedProducts()}
                                    vetDetails={this.state.vetDetails}
                                    hasSelected={(selected) => this.setState({ hasSelectedProduct: selected })}
                                    bundleLists={this.state.bundleLists}
                                    style={{ paddingTop: 75 }}
                                />
                            }
                        </Col>
                    </Row>
                );
            case COMMUNAL_VETUNITY_STEPS.confirmation.hash:
                if (this.state.divider) this.setState({ divider: false });
                return <BookingDetails 
                            booking={this.props.booking}
                            vetDetails={this.state.vetDetails} 
                            ref={this.bookingDetailsRef} 
                            headerTitle={this.state.headerTitle}/>
            default:
                return null;
        }
    }

    render() {
        return (
            <BookingContext.Provider 
                value={{
                    ...this.state, 
                    setState: (state) => this.setState(state),
                }}
            >
                <div className="main-container">
                    <NavbarSecondary />
                    <NavbarPrimary />
                    <div className="body-content">
                        {
                            <PageTitle title={`${this.state.isEdit ? 'Edit' : 'New'} ${localStorage.getItem('service-type-name').toLocaleLowerCase().includes('wildlife') ? 'stray/wildlife' : 'pet'}  communal cremation`} />
                        }
                        {
                            this.props.location.hash && !this.state.isSubmitted
                                ? <Stepper steps={this.state.steps} />
                                : null
                        }
                        {
                            !this.state.isSubmitted
                            ? this.state.isBookingLoaded ? (
                                    <ContentCard
                                        className="mt-28"
                                        divider={this.state.divider}
                                        headerTitle={this.state.headerTitle}
                                        headerStyle={{ paddingBottom: '10px' }}
                                        headerSubComponent={this.headerSubcomponentView()}
                                    >
                                        <Container className={ "nb-container " + (this.props.location.hash === COMMUNAL_VETUNITY_STEPS.confirmation.hash ? 'confirmation-page' : '')}>
                                            {this.stepFormView()}
                                        </Container>
                                    </ContentCard>
                                ) : '' : (
                                    <BookingSubmitted bookingId={this.state.bookingId} vetDetails={this.state.vetDetails} isUnsubmitted={this.state.isUnsubmitted}/>
                                )
                        }
                    </div>
                    {
                        !this.state.isSubmitted
                            ? (
                                <FooterBtnActions
                                    isEdit={this.state.isEdit}
                                    currentPage={this.props.location.hash}
                                    showSpinner={this.state.isLoading}
                                    nextBtnText={
                                        this.props.location.hash === COMMUNAL_VETUNITY_STEPS.confirmation.hash
                                            ? this.state.isUnsubmitted ? 'Submit booking' : 'Confirm'
                                            : this.state.isUnsubmitted ? 'Next' : 'Save & Next'
                                    }
                                    cancelBtnOnCLick={() => this.navigateCancel()}
                                    prevBtnOnCLick={() => this.navigatePrev()}
                                    nextBtnOnCLick={() => this.onSubmit()}
                                />
                            ) : (
                                <FooterBtnActions
                                    nextBtnText="View Booking"
                                    nextBtnOnCLick={() => this.onSubmit()}
                                />
                            )
                    }
                    <AlertDismissible
                        show={this.state.alertFail.show}
                        type="danger"
                        text={this.state.alertFail.message}
                        onClose={() => this.setState({
                            alertFail: {
                                show: false,
                                message: DEFAULT_ERROR_MSG,
                            }
                        })}
                    />
                </div>
            </BookingContext.Provider>
        );
    }
}

const mapStateToProps = (state) => ({ booking: state.booking });

const mapDispatchToProps = (dispatch) => {
    return {
        updateBooking: (bookingObj) => dispatch(updateBooking(bookingObj)),
        clearBooking: () => dispatch(clearBooking())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PrivateCremation));
